var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0874 8.3101C19.9991 8.36163 17.8963 9.44912 17.8963 11.8603C17.9954 14.6102 20.5499 15.5745 20.5938 15.5745C20.5499 15.626 20.2081 16.8882 19.1955 18.2113C18.3918 19.3509 17.4999 20.5 16.1454 20.5C14.857 20.5 14.3945 19.7404 12.9079 19.7404C11.3114 19.7404 10.8597 20.5 9.63736 20.5C8.28289 20.5 7.32485 19.2894 6.47741 18.1604C5.37646 16.6828 4.44068 14.3639 4.40764 12.1374C4.38538 10.9576 4.62812 9.79779 5.24431 8.81269C6.11402 7.43744 7.6667 6.50387 9.3623 6.47309C10.6615 6.43226 11.8177 7.30426 12.6106 7.30426C13.3704 7.30426 14.7909 6.47309 16.3982 6.47309C17.092 6.47376 18.942 6.6685 20.0874 8.3101ZM12.5007 6.23752C12.2694 5.16007 12.9079 4.08262 13.5025 3.39533C14.2624 2.56416 15.4624 2 16.4973 2C16.5634 3.07745 16.1447 4.13415 15.3964 4.90376C14.7249 5.73493 13.5686 6.36066 12.5007 6.23752Z",
    fill: "#1B1B24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/Apple.856e140ae682b6a6b20bc4fe26572c39.svg";
export { ForwardRef as ReactComponent };